import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const categoryLabels = {
  "overcoming-fears": "Overcoming Fears",
  "cultural-awakening": "Cultural Awakening",
  "physical-achievement": "Physical Achievement",
  "spiritual-journey": "Spiritual Journey",
};

const categoryColors = {
  "overcoming-fears": "bg-orange-100 text-orange-700",
  "cultural-awakening": "bg-blue-100 text-blue-700",
  "physical-achievement": "bg-green-100 text-green-700",
  "spiritual-journey": "bg-purple-100 text-purple-700",
};

const StoryCard = ({ story, onReadMore }) => {
  const labelColor =
    categoryColors[story?.category] || "bg-primary/10 text-primary";
  const labelText =
    categoryLabels[story?.category] || story?.category;

  return (
    <div className="bg-card rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group flex flex-col">
      {/* Image */}
      <div className="relative overflow-hidden" style={{ paddingTop: "60%" }}>
        <img
          src={story?.featuredImage}
          alt={story?.title}
          className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
          onError={(e) => { e.target.src = "/assets/images/no_image.png"; }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
        {/* Category badge */}
        <span className={`absolute top-4 left-4 text-xs font-semibold px-3 py-1 rounded-full ${labelColor}`}>
          {labelText}
        </span>
      </div>

      {/* Body */}
      <div className="flex flex-col flex-1 p-5 gap-3">
        {/* Author row */}
        <div className="flex items-center gap-3">
          <img
            src={story?.traveler?.avatar}
            alt={story?.traveler?.name}
            className="w-9 h-9 rounded-full object-cover flex-shrink-0"
            onError={(e) => { e.target.src = "/assets/images/no_image.png"; }}
          />
          <div className="min-w-0">
            <p className="text-sm font-semibold text-foreground truncate">
              {story?.traveler?.name}
            </p>
            <p className="text-xs text-text-secondary truncate">
              {story?.traveler?.location} · {story?.trekDate}
            </p>
          </div>
        </div>

        {/* Title */}
        <h3 className="font-headline font-bold text-base text-foreground line-clamp-2 leading-snug">
          {story?.title}
        </h3>

        {/* Excerpt */}
        <p className="text-sm text-text-secondary line-clamp-3 leading-relaxed flex-1">
          {story?.excerpt}
        </p>

        {/* Meta */}
        <div className="flex items-center gap-4 text-xs text-text-secondary pt-1 border-t border-border">
          <span className="flex items-center gap-1">
            <Icon name="MapPin" size={13} className="text-primary" />
            {story?.trek}
          </span>
          <span className="flex items-center gap-1">
            <Icon name="Clock" size={13} className="text-primary" />
            {story?.readTime}
          </span>
          <span className="flex items-center gap-1 ml-auto">
            {[...Array(5)].map((_, i) => (
              <Icon
                key={i}
                name="Star"
                size={12}
                className={i < story?.rating ? "text-yellow-400" : "text-gray-300"}
              />
            ))}
          </span>
        </div>

        {/* CTA */}
        <Button
          variant="outline"
          fullWidth
          onClick={() => onReadMore(story)}
          className="group-hover:bg-primary group-hover:text-white group-hover:border-primary transition-colors duration-300 text-sm font-medium mt-1"
        >
          Read Full Story
        </Button>
      </div>
    </div>
  );
};

export default StoryCard;
